import React, { useEffect, useRef } from 'react';
import { galleryItems } from '../../data/galleryItems';

const GallerySection = () => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('gallery-card-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cardRefs.current.forEach((card) => card && observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery" className="relative overflow-hidden bg-gradient-to-b from-white via-rose-50/40 to-white py-20 px-4 sm:px-6 lg:px-8">
      <div className="gallery-ribbon" aria-hidden="true" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/70 px-4 py-1 text-xs font-semibold tracking-[0.4em] text-pink-600 shadow-sm">
            <span className="h-1 w-1 rounded-full bg-pink-500" aria-hidden="true" />
            Gallery
          </span>
          <h2 className="mt-5 text-3xl sm:text-4xl font-bold font-serif text-gray-900 mb-4">
            Sweet Creations Gallery
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Each cake is a unique masterpiece, designed to make your celebrations unforgettable
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryItems.map((cake, index) => (
            <div
              key={cake.id}
              ref={(el) => {
                cardRefs.current[index] = el;
              }}
              className="gallery-card group relative overflow-hidden rounded-3xl bg-white/70 ring-1 ring-white/40 shadow-lg"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={cake.image}
                  alt={cake.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <span className="gallery-card-glow" aria-hidden="true" />
              </div>
              <div className="p-6">
                <span className="text-xs uppercase tracking-[0.3em] text-pink-500/90">{cake.category}</span>
                <h3 className="mt-3 text-2xl font-serif text-gray-900">{cake.title}</h3>
                <p className="mt-2 text-gray-600 text-sm">{cake.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <a
            href="#order"
            className="inline-flex items-center gap-2 rounded-full bg-gray-900/90 px-8 py-3 text-white font-semibold tracking-wide shadow-xl shadow-gray-900/20 transition hover:-translate-y-0.5 hover:bg-gray-900"
          >
            Start Your Custom Order
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
